import CommonNodataFound from "../CommonNodataFound";

export const Tablenodatafound = () => {
  return (
    <>
      <tr>
        <td colSpan={50} className="text-center">
          <CommonNodataFound />
        </td>
      </tr>
    </>
  );
};
